let message = {
    pushsn: "Trace ID",
    deviceCode: "Device No.",
    merchantName: "Merchant name",
    merchantCode: "Merchant ID",
    content: "Message Content",
    pushTime: "Push Time",
    responseTime: "Response Time",
    pushResult: "Status",
    appId: "Application",
    resultTrue: "Success",
    resultFalse: "Failed",
    orgName: "Organization",
    pushTimeRange: "Push time range",
    messageDetail: "Message detail",
    amount: "Amount",
    enterAmount: "Please enter amount",
    push: "Push",
    status: "Status",
    result0: "Success",
    result1: "Pending",
    result2: "Timeout",
    result3: "Device Busy",
    result4: "Device Offline",
    result5: "Device Error",
    messageTotalNumber: "Message Count",
    messageTotalNumberSuffix: "Message Count",
    amountSuffix: "Received amount (yuan)",
    broadcastAmountNumber: "Total amount of broadcast",
    weekMessageTrend: "Trend chart of messages",
    weekAmountTrend: "Trend chart of payment amount in the past week",
    pushAudio: "Push Mp3 File (For Testing Only)",
    audioFile: "Audio File",
    selectFile: "Please select Mp3 files smaller than 40Kb"
}

export default message
